import { Button } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import clsx from 'clsx';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useAmplitude } from 'hooks/useAmplitude';
import { useNavigate } from 'react-router-dom';
import ErrorIcon from 'svg/ErrorIcon';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import NavStyles from '../Navigation/Navigation.module.css';
import styles from './AddNewApplicationNavItem.module.css';

type TProps = {
  className?: string;
  showDesktopVersion?: boolean;
};

export const AddNewApplicationNavItem = ({
  className,
  showDesktopVersion = true,
}: TProps) => {
  const {
    hasProductsForApplication,
    isContextError,
    isIntroducerError,
    checkIntroducerPermission,
  } = useIntroducerData();
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();

  const handleStartNewAppClick = () => {
    trackEvent(AMPLITUDE_EVENTS.signupCTAClicked, {
      'CTA location': 'Navigation',
      'CTA text': 'Create new app',
      'CTA URL': PATH_NAMES.newApplicationStep0(),
    });

    return navigate(PATH_NAMES.newApplicationStep0());
  };

  return (
    <Button
      data-tracking-id="Start new application"
      variant="primary"
      size="small"
      onClick={handleStartNewAppClick}
      disabled={
        isContextError ||
        isIntroducerError ||
        !hasProductsForApplication ||
        !checkIntroducerPermission('can_create_applications')
      }
      className={clsx(
        NavStyles.actionBtn,
        styles.NewApplicationButton,
        className,
      )}
    >
      {(isContextError || isIntroducerError) && (
        <ErrorIcon data-testid="error-icon" />
      )}

      <span className={styles.NewApplicationText}>
        {showDesktopVersion ? t`Create a new app` : t`New app`}
      </span>
    </Button>
  );
};
